import { ApiResponse } from '../../classes/Api';
import { ApiUserShallow } from '../user';

export enum ApiSubscriptionType {
    standard = 'standard',
    standardMonthFree = 'standard_month_free',
    premium = 'premium',
    tester = 'tester',
    testerMonthFree = 'tester_month_free',
    internal = 'internal',
    pack = 'pack',
    premiumEnergy = 'premium_energy',
}

export enum ApiSubscriptionMetaType {
    subscription = 'subscription',
    pack = 'pack',
}

export enum ApiSubscriptionStatus {
    pending = 'pending',
    active = 'active',
    expiring = 'expiring',
    // renewed = 'renewed', TODO: add
    inactive = 'inactive',
}

export type ApiSubscriptionBase = {
    id: string;
    idRepresentative: string;
    type: ApiSubscriptionType;
    startDate: string;
    endDate: string;
    status: ApiSubscriptionStatus;
    companyId: string;
    metaType: ApiSubscriptionMetaType;
};

export type ApiSubscription = ApiSubscriptionBase & { user: ApiUserShallow };

export type ApiSubscriptionListResponse = ApiResponse<{ items: ApiSubscription[] }>;
